<template>
	<v-container pt-0>
		<v-row>
			<v-col class="d-flex justify-center align-center pb-0">
				<div :class="['text-h6', 'pa-2']">{{ $t('titles.participants') }}</div>
			</v-col>
		</v-row>
		<v-row>
			<v-container cols="12" class="overflow-container pt-0">
				<v-row v-for="(item, key) in participants" :key="key">
					<div class="bordered-col d-flex justify-space-between">
						<div :class="['text-body-1', 'pa-2']">{{ item.first_name + ' ' + item.last_name }}</div>
						<div v-if="canEdit">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn icon v-bind="attrs" @click="deleteParticipant(item.id)" v-on="on">
										<v-icon small>fa-trash</v-icon>
									</v-btn>
								</template>
								<span>{{ $t('tooltips.delete') }}</span>
							</v-tooltip>
						</div>
					</div>
				</v-row>
				<v-row v-if="participants.length == 0">
					<v-col>
						<div :class="['text-body-1', 'pa-2', 'd-flex', 'justify-center']">
							{{ $t('titles.noParticipants') }}
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-row>
		<v-spacer></v-spacer>
	</v-container>
</template>

<script>
export default {
	name: 'Participants',
	components: {},
	props: {
		appointmentId: [String, Number],
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	watch: {
		appointmentId(newVal) {
			if (newVal != 0) {
				this.getParticipants();
			}
		},
	},
	data() {
		return {
			participants: [],
			participant: null,
			participantValidation: true,
		};
	},
	methods: {
		getParticipants() {
			let vm = this;
			this.$APICall('get', 'appointments-participants/' + this.appointmentId, {}, (data, succes) => {
				if (succes) {
					vm.participants = data;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		deleteParticipant(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.$APICall(
						'post',
						'participants/' + id + '/delete',
						{ appointment: this.appointmentId, id: id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.getParticipants();
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
	},
	mounted() {
		let vm = this;
		this.$modalBus.$on('reloadParticipants', () => {
			vm.getParticipants();
		});
		if (this.appointmentId !== 0) {
			this.getParticipants();
		}
	},
};
</script>

<style scoped>
.bordered-col {
	border: 1px solid #e0e0e0;
	padding: 4px;
	border-radius: 4px;
	width: 100%;
	margin-top: 4px;
}
.overflow-container {
	max-height: 440px;
	overflow-y: auto;
}
</style>
